import { render } from "./MyTotalAgentReport.vue?vue&type=template&id=cfc28ec0"
import script from "./MyTotalAgentReport.vue?vue&type=script&lang=js"
export * from "./MyTotalAgentReport.vue?vue&type=script&lang=js"

import "./MyTotalAgentReport.vue?vue&type=style&index=0&id=cfc28ec0&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__